/**
 * Validation utilities for API requests
 */

/**
 * Validates if a string is a valid ISO date in UTC format (ending with Z)
 * @param {string} dateStr - The date string to validate
 * @returns {boolean} - True if valid ISO date in UTC format
 */
export const isValidISODate = (dateStr) => {
  if (!dateStr) return false;
  // Check if it's a valid ISO date string ending with Z (UTC)
  return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?Z$/.test(dateStr);
};

/**
 * Validates if a string is a valid Proctor User SID
 * @param {string} sid - The SID to validate
 * @returns {boolean} - True if valid Proctor User SID
 */
export const isValidProctorUserSid = (sid) => {
  if (!sid) return false;
  return /^PU[a-f0-9]{32}$/.test(sid);
};

/**
 * Validates if a string is a valid Exam SID
 * @param {string} sid - The SID to validate
 * @returns {boolean} - True if valid Exam SID
 */
export const isValidExamSid = (sid) => {
  if (!sid) return false;
  return /^EX[a-f0-9]{32}$/.test(sid);
};

/**
 * Validates if a value is a valid session status
 * @param {string} status - The status to validate
 * @returns {boolean} - True if valid status
 */
export const isValidSessionStatus = (status) => {
  const validStatuses = [
    'Scheduled', 
    'Onboarding', 
    'Closed', 
    'In Progress', 
    'Checked In', 
    'Processing', 
    'Disconnected', 
    'Pending Reconnection'
  ];
  return validStatuses.includes(status) || status === null || status === '';
};

/**
 * Validates if a value is a valid duration in minutes
 * @param {number|string} minutes - The duration to validate
 * @returns {boolean} - True if valid duration
 */
export const isValidDurationMinutes = (minutes) => {
  const duration = Number(minutes);
  return !isNaN(duration) && duration >= 1;
};
